var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex flex-row align-items-end float-right meta"},[_c('div',{staticClass:"px-1 font-weight-bold"},[_vm._v(_vm._s(_vm.getAuthorName(_vm.author)))]),_c('div',{staticClass:"px-1"},[_vm._v(_vm._s(_vm.formatDate(_vm.when)))])])
}
var staticRenderFns = []

export { render, staticRenderFns }